interface LoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizeMap = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-10 w-10',
  xl: 'h-12 w-12',
};

export default function Loader({ size = 'md' }: LoaderProps) {
  return (
    <div className={`inline-block animate-spin rounded-full border-b-2 border-[#699269] ${sizeMap[size]}`}></div>
  );
}

